import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DashboardStatsDataInterface } from '../../models/dashboard/dashboard/dashboard-stats';

interface IInitialState {
  dashboardStatsData: DashboardStatsDataInterface | null;
}

const initialState: IInitialState = {
  dashboardStatsData: null,
};

const dashboardStatsSlice = createSlice({
  name: 'dashboardStatsData',
  initialState,
  reducers: {
    setDashboardStatsData(
      state,
      action: PayloadAction<DashboardStatsDataInterface>,
    ) {
      state.dashboardStatsData = action.payload;
    },
  },
});

export const dashboardStatsActions = dashboardStatsSlice.actions;
export default dashboardStatsSlice.reducer;
